module.exports = __webpack_public_path__ + "img/3.111c23cb.png";